export const cilChevronDoubleRight = ["24 24","<path d='M23.622 11.997l0.002-0.002-8.834-8.83-3.725 3.725 5.11 5.11-5.11 5.11 3.725 3.725 8.835-8.835zM14.79 18.714l-1.603-1.604 5.11-5.11-5.11-5.11 1.603-1.604 6.718 6.714-1.605 1.605-0.002-0.002-0.003 0.003z'></path><path d='M13.256 12l-0.003-0.003 0.002-0.002-3.191-3.191-0.529-0.525-5.114-5.113-3.725 3.725 5.11 5.11-5.11 5.11 3.725 3.725 8.307-8.303zM9.53 13.609l-0.002-0.002-5.107 5.107-1.603-1.604 5.11-5.11-5.11-5.11 1.603-1.604 6.718 6.714z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-double-right.js
// module id = null
// module chunks = 